module.exports = __webpack_public_path__ + "img/gasbot-side-right.6008e28e.webp";